export const production_app_url = 'insight.commonapp.org';
export const uat_app_url = 'insight.staging.commonapp.org';
export const common_app_login_url = 'https://members.commonapp.org';
export const qa_set_env_flag = 'qa=1D3A0EACA9DABF1C20CEF';
export const session_length = 60; //minutes
export const shared_report_options = {
    "hideTabs": true,
    "showShareOptions": false,
    "hideToolbar": true
};
export const non_licensed_categories = ['Volume'];
export const google_analytics_id = 'UA-108975058-1';


// WEBPACK FOOTER //
// ./src/config/constants.js